import { useState } from "react";
import { api } from "../../api/api";
import Button from "../button/Button";

export default function RecuperarSenhaModal({ isOpen, onClose }) {
  const [etapa, setEtapa] = useState(1);
  const [email, setEmail] = useState("");
  const [codigo, setCodigo] = useState("");
  const [novaSenha, setNovaSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState("");
  const [sucesso, setSucesso] = useState("");

  if (!isOpen) return null;

  function handleFechar() {
    setEtapa(1);
    setEmail("");
    setCodigo("");
    setNovaSenha("");
    setErro("");
    setSucesso("");
    onClose();
  }

  async function handleSolicitarCodigo(e) {
    e.preventDefault();
    setErro("");
    setSucesso("");
    setLoading(true);

    try {
      const response = await api.post("/auth/forgot-password", { email });

      // Se a requisição foi bem-sucedida (status 200), avança para a etapa 2
      setEtapa(2);
      setSucesso(response.data?.mensagem || "Código enviado para seu e-mail!");
    } catch (err) {
      // Captura a mensagem retornada pelo backend (ex: "Contate o administrador.")
      const mensagemErro = err.response?.data?.erro || "Erro ao solicitar recuperação.";
      setErro(mensagemErro);
      // Não altera a variável 'etapa', mantendo a tela na etapa 1!
    } finally {
      setLoading(false);
    }
  }

  async function handleRedefinir(e) {
    e.preventDefault();
    setErro("");
    setLoading(true);

    try {
      await api.post("/auth/reset-password-code", { email, codigo, novaSenha });
      alert("Senha redefinida com sucesso! Faça login com a nova senha.");
      handleFechar();
    } catch (err) {
      setErro(err.response?.data?.erro || "Erro ao redefinir senha.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="modal-overlay">
      <div className="login-card fade">
        <h2 className="login-title">Recuperação de Senha</h2>

        {etapa === 1 ? (
          <form onSubmit={handleSolicitarCodigo} className="login-form">
            <div className="login-group">
              <label>Informe seu e-mail cadastrado</label>
              <input
                className="input"
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            {erro && <div className="login-error">{erro}</div>}
            <Button type="submit" loading={loading} className="btn login-button">
              Enviar Código
            </Button>
            <button type="button" className="btn login-button-register" onClick={handleFechar}>
              Cancelar
            </button>
          </form>
        ) : (
          <form onSubmit={handleRedefinir} className="login-form">
            {sucesso && <div style={{ color: "green", marginBottom: "10px", fontSize: "14px" }}>{sucesso}</div>}
            <div className="login-group">
              <label>Código de 6 dígitos</label>
              <input
                className="input"
                type="text"
                maxLength={6}
                placeholder="000000"
                value={codigo}
                onChange={(e) => setCodigo(e.target.value)}
                required
              />
            </div>
            <div className="login-group">
              <label>Nova Senha</label>
              <input
                className="input"
                type="password"
                placeholder="Digite a nova senha"
                value={novaSenha}
                onChange={(e) => setNovaSenha(e.target.value)}
                required
              />
            </div>
            {erro && <div className="login-error">{erro}</div>}
            <Button type="submit" loading={loading} className="btn login-button">
              Redefinir Senha
            </Button>
            <button 
              type="button" 
              className="btn login-button-register" 
              onClick={() => { setEtapa(1); setErro(""); setSucesso(""); }}
            >
              Voltar
            </button>
          </form>
        )}
      </div>
    </div>
  );
}